import axiosInstance from '@/utils/api.js'

var state = {
  invoices: []
}

var getters = {
  INVOICES: (state) => {
    return state.invoices
  }
}

var mutations = {
  SET_INVOICES: (state, payload) => {
    state.invoices = payload
  }
}

var actions = {
  GET_INVOICES: async (context, payload) => {
    let result = await axiosInstance.get('/users/invoices?user_id=' + payload.user_id + '&account_id=' + payload.account_id)
    if (result.status === 200) {
      context.commit('SET_INVOICES', result.data)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/reports/invoices.js